import { applySort, getMatch, proceedHTTPRequest } from "../../../assets/js/common";
import { CFG_FEED_URL, CFG_MATCH_STORY_API, CFG_MATCH_STORY_ENABLED_FROM, CFG_HEAD_TO_HEAD_IMAGE_FROM } from "../../../assets/js/config";
import { FORMAT_FEED } from "../../types";

const fantasy_tips_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.fantasy_tips_store) ? window.__ROI_STATE_DATA__.fantasy_tips_store : {
        page: 'Fantasy Tips page',
        fantasy_tips_store_filled: false,
        is_loading: true,
        module: null,
        client_id: "ZW2bhUzo/PSITxt9zEdszA==",
        feed_data: [],
        no_article_pics: true,
        page_no: 1,
        item_count: 10,
        source_id_filter: [20, 12],
        article_pt: null,
        article_mt: null,
        hasMatchInfoData: false,
        matchStories: "",
        story_created_date: null,
        story_updated_date: null,
        show_htoh_image: false,
        isArticleAvailable: false,
    }),
    actions: {
        fetchFeed: ({ state, commit, rootState }, payload) => {
            let { match_detail_store, route, ismobile } = rootState;
            if (match_detail_store.no_matches_active) return;
            let match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);
            if (!match) return;
            let match_code = match.code;
            state.show_htoh_image = (new Date(CFG_HEAD_TO_HEAD_IMAGE_FROM) - new Date(match.start_date)) < 0;
            let isStoriesEnabled = (new Date(CFG_MATCH_STORY_ENABLED_FROM) - new Date(match.start_date)) < 0;
            state.isArticleAvailable = isStoriesEnabled;
            if (isStoriesEnabled) {
                let lang = route.path && route.path.includes("/hi/") ? "hi/" : "";
                let storyMode = "desktop";
                if (payload && payload.isAmp) {
                    storyMode = "amp";
                } else if (ismobile) {
                    storyMode = "mobile";
                }
                let storyUrl = CFG_MATCH_STORY_API.replace("{{mode}}", storyMode).replace("{{match_id}}", match_code).replace("{{lang}}", lang);
                state.is_loading = true;
                return proceedHTTPRequest({
                    url: storyUrl,
                    method: "get",
                    can_append: false,
                    add_headers: false,
                })
                    .then((response) => {
                        state.fantasy_tips_store_filled = true;
                        state.is_loading = false;
                        state.matchStories = (response && response.html) || "";
                        // if (response.created_date) {
                        //     state.story_created_date = response.created_date;
                        // }
                        if (response.last_updated) {
                            state.story_updated_date = response.last_updated;
                            state.story_created_date = response.last_updated;
                        }
                        if (state.matchStories) {
                            state.hasMatchInfoData = true;
                        }
                    })
                    .catch((e) => {
                        state.fantasy_tips_store_filled = true;
                        state.is_loading = false;
                        state.hasMatchInfoData = false;
                        state.matchStories = "";
                        state.story_created_date = null;
                        state.story_updated_date = null;
                    });
            } else {
                let casse_url = CFG_FEED_URL.replace(/{{client_id}}/, state.client_id)
                    .replace(
                        /{{match_id}}/,
                        match_code.slice(match_code.length - 6, match_code.length)
                    )
                    .replace(/{{item_count}}/, state.item_count)
                    .replace(/{{page_no}}/, state.page_no);

                state.is_loading = true;
                return proceedHTTPRequest({
                    method: "get",
                    can_append: false,
                    add_headers: false,
                    url: casse_url,
                })
                    .then((response) => {
                        return commit(FORMAT_FEED, response);
                    })
                    .catch((e) => {
                        return commit(FORMAT_FEED, {
                            assets: [],
                        });
                    });
            }
        },
        resetFeed: ({ state }) => {
            state.page_no = 1;
            state.feed_data = [];
            state.matchStories = "";
            state.show_htoh_image = false;
            state.isArticleAvailable = false;
            state.story_created_date = null;
            state.story_updated_date = null;
        }
    },
    mutations: {
        [FORMAT_FEED]: (state, payload) => {
            let { assets } = payload;
            state.fantasy_tips_store_filled = true;
            // if(typeof window !== "undefined"){
            state.is_loading = false;
            // }
            assets = assets.filter((a) =>
                state.source_id_filter.includes(a.source_id)
            );

            for (let i = 0; i < assets.length; i++) {
                let a = assets[i];
                let aData = a.custom_metadata && a.custom_metadata.asset;
                if (aData && aData.length) {
                    try {
                        aData = aData.replace(/\r?\n|\r/g, " ");
                        aData = aData.replace(/\t/g, "    ");
                        aData = JSON.parse(aData);
                        assets[i]["asset"] = aData;
                    } catch (e) {
                        console.warn(e.stack);
                    }
                }

                assets[i]._pt = new Date(a.publish_time_utc).getTime();

                if (state.feed_data.length) {
                    let does_exist = state.feed_data.findIndex(
                        (asset) => asset.id === a.id
                    );
                    if (does_exist !== -1) {
                        //replace with new assest
                        Object.assign(
                            state.feed_data[
                            state.feed_data.findIndex((el) => el.id === a.id)
                            ],
                            a
                        );
                    } else {
                        //push and sort by assest_order to rearrange
                        state.feed_data.push(a);
                    }
                }
            }

            if (!state.feed_data.length) {
                state.feed_data = assets;
            }

            if (state.feed_data.length) {
                let sorted_by_pt = applySort(state.feed_data, "_pt", "desc");
                state.article_mt = sorted_by_pt[0].publish_time_utc;
                state.article_pt =
                    sorted_by_pt[sorted_by_pt.length - 1].publish_time_utc;
            }

            state.feed_data = applySort(
                state.feed_data,
                "asset_order",
                "desc"
            );

            if (state.feed_data.length) {
                let is_display_url = state.feed_data.find(f => f.display_pic);
                state.no_article_pics = !is_display_url;
                state.hasMatchInfoData = true;
            }
            if (!state.feed_data.length && typeof window === "undefined") {
                state.hasMatchInfoData = false;
            }
        },
    }
}

export default fantasy_tips_store;